/**
 * @flow
 */

export const filterByPromoCode = (promoCodes: array) => ({
    type: 'STATISTICS.FILTER.BY.PROMO.CODE',
    promoCodes,
});
